import publisher from './publisher'
import classify from './classify'
import wordType from './wordType'
import preview from './preview'
import label from './label'
import word from './word'
import list from './list'
import special from './special'
import keywords from './keywords'

export default {
  ...list,
  ...word,
  ...label,
  ...preview,
  ...wordType,
  ...classify,
  ...publisher,
  ...special,
  ...keywords
}
